export { ISelectionOptions, Selection } from '@fluentui/utilities';
